import Component from '@cell/cell-core/component/component';

import './product-details.scss';

class ProductDetails extends Component {
  constructor() {
    super();
  }

  componentDidMount() {}
}

customElements.define('product-details', ProductDetails);
